"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.EntryProvider = void 0;
const domain_1 = require("../../../domain");
const lodash_1 = __importDefault(require("lodash"));
const operators_1 = require("rxjs/operators");
const BaseDataProvider_1 = require("./BaseDataProvider");
class EntryProvider extends BaseDataProvider_1.BaseDataProvider {
    constructor() {
        super(...arguments);
        this.entriesForUserAndAssignments = async (userId, assignmentIds) => {
            const entryIds = assignmentIds.map((id) => domain_1.AssignmentEntry.createId(id, userId));
            return await this.entryByIds(entryIds);
        };
        this.entryByIds = async (ids) => {
            const results = await Promise.all(ids.map((id) => this.entry(id)));
            return lodash_1.default.compact(results);
        };
        this.entryQuery = (options) => {
            let query = this.refs.entries();
            query = lodash_1.default.isNil(options.type) ? query : query.where('type', '==', options.type);
            query = lodash_1.default.isNil(options.userId) ? query : query.where('userId', '==', options.userId);
            query = lodash_1.default.isNil(options.testPhase) ? query : query.where('testData.phase', '==', options.testPhase);
            query = lodash_1.default.isNil(options.limit) ? query : query.limit(options.limit);
            return query;
        };
    }
    entriesForAssignment(assignmentId) {
        const query = this.refs.entries().where('assignmentId', '==', assignmentId);
        return this.collectionPromise(query);
    }
    anyEntryForAssignment(assignmentId) {
        const query = this.refs.entries().where('assignmentId', '==', assignmentId).limit(1);
        return this.collectionPromise(query);
    }
    entriesForAssignmentStream(assignmentId) {
        const query = this.refs.entries().where('assignmentId', '==', assignmentId);
        return this.collectionDataStream(query, false);
    }
    entryStream(id) {
        return this.docDataStream(this.refs.entry(id), true);
    }
    entry(id) {
        return this.docPromise(this.refs.entry(id));
    }
    entryForUser(assignmentId, userId) {
        return this.entry(domain_1.AssignmentEntry.createId(assignmentId, userId));
    }
    async entryForUsers(assignmentId, userIds) {
        const ids = userIds.map((id) => domain_1.AssignmentEntry.createId(assignmentId, id));
        return await this.entryByIds(ids);
    }
    entryForUserStream(assignmentId, userId) {
        return this.entryStream(domain_1.AssignmentEntry.createId(assignmentId, userId));
    }
    pinEntriesStream(assignmentId, pinId) {
        return this.entriesForAssignmentStream(assignmentId).pipe((0, operators_1.map)((values) => domain_1.AssignmentEntry.pinEntryFromEntries(values, pinId)));
    }
    pinEntryForUserStream(assignmentId, userId, pinId) {
        return this.entryForUserStream(assignmentId, userId).pipe((0, operators_1.map)((value) => domain_1.AssignmentEntry.entryForPin(value, pinId)));
    }
    async pinEntryForUser(assignmentId, userId, pinId) {
        const entry = await this.entry(domain_1.AssignmentEntry.createId(assignmentId, userId));
        return domain_1.AssignmentEntry.entryForPin(entry, pinId);
    }
    allOpenEntriesForUser(userId) {
        const query = this.entryQuery({
            userId,
            testPhase: 'started',
            limit: 20,
        });
        return this.collectionPromise(query);
    }
    async hasOpenTestForUser(userId) {
        const query = this.entryQuery({
            userId,
            testPhase: 'started',
            limit: 1,
        });
        const [test] = await this.collectionPromise(query);
        return !!test;
    }
}
exports.EntryProvider = EntryProvider;
//# sourceMappingURL=EntryProvider.js.map